import { IBoundedContext } from './bounded-context';

export class Configuration {

    constructor(private _boundedContexts: IBoundedContext[]) { }

    getContext(name: string) {
        return this._boundedContexts.find(c => c.name === name);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/config/configuration.ts